import { n as e, t } from "../../../v20240730-DFhmpDyF.js";
export { e as DashboardApi20240730, t as dashboard20240730Client };
